function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "forward"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.555 10.168-6-4c-.306-.204-.702-.224-1.026-.05-.326.174-.529.513-.529.882v1.032c-8.774.57-11.903 8.53-11.935 8.613-.154.404-.03.862.307 1.134.183.147.405.221.628.221.189 0 .379-.054.545-.161 3.948-2.566 7.779-2.95 9.712-2.95.281 0 .53.008.743.02v1.091c0 .388.225.741.576.905.35.165.766.112 1.064-.137l6-5c.242-.202.375-.507.358-.822-.017-.314-.181-.603-.443-.778zm-5.563 3.704c-.056-.431-.386-.783-.823-.857-.03-.006-.747-.126-1.912-.126-1.616 0-4.423.239-7.574 1.563 1.647-2.059 4.58-4.452 9.317-4.452.553 0 1-.447 1-1v-.132l3.331 2.221z"
}));

var Svg049Forward = function Svg049Forward(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg049Forward, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/049-forward.f7ec0a78.svg";
export { ForwardRef as ReactComponent };